import { render } from "./QToggle.vue?vue&type=template&id=2b27e90c&scoped=true"
import script from "./QToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./QToggle.vue?vue&type=script&setup=true&lang=js"

import "./QToggle.vue?vue&type=style&index=0&id=2b27e90c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b27e90c"],['__file',"src/components/UI/buttons/QToggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b27e90c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b27e90c', __exports__)) {
    api.reload('2b27e90c', __exports__)
  }
  
  module.hot.accept("./QToggle.vue?vue&type=template&id=2b27e90c&scoped=true", () => {
    api.rerender('2b27e90c', render)
  })

}


export default __exports__